import { Component, OnInit } from '@angular/core';
import {InvoiceListService} from './invoice-list.service';
import {MatTableDataSource} from '@angular/material/table';
import {Financial} from '../models/Financial';
import {InvoiceNew} from '../models/InvoiceNew';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {

  constructor(
      private httpService: InvoiceListService,
      private router: Router,
  ) { }

  public dataSourceInvoices: MatTableDataSource<InvoiceNew> = new MatTableDataSource<InvoiceNew>();
  public displayedColumns: string[] = [
    // 'CODIGO_FATURA',
    'MES_REFERENCIA',
    'DESCRICAO_FATURA',
    'DATA_EMISSAO',
    'DATA_VENCIMENTO',
    'DATA_PAGAMENTO',
    'VALOR_TOTAL',
  ];

  ngOnInit(): void {
    this.httpService.showSpinner();
    this.httpService.getFaturas().subscribe(invoices => {
      this.dataSourceInvoices = new MatTableDataSource<InvoiceNew>(invoices as any);
      this.httpService.hideSpinner();
    }, error => {
      console.error(error);
      this.httpService.toasterError('Houve um erro ao montar esta tela');
      this.httpService.hideSpinner();
    });
  }
  public redirect(id: string): void{
    this.router.navigate(['principal/faturas/' + id]);
  }
}
